var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketFeatureIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.997,
    height: 81,
    viewBox: "0 0 80.997 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3194",
    "data-name": "Rectangle 3194",
    width: 66.589,
    height: 66.589,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83194",
    "data-name": "Group 83194",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5588",
    "data-name": "Path 5588",
    d: "M40.5,0A40.5,40.5,0,1,1,0,40.5,40.5,40.5,0,0,1,40.5,0Z",
    transform: "translate(0 0)",
    fill: "#ffeaae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11575",
    "data-name": "Group 11575",
    transform: "translate(6.789 8.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11574",
    "data-name": "Group 11574",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5526",
    "data-name": "Path 5526",
    d: "M9.734,35.074c-1.025.62-1.05,1.953-.058,2.977l2.368,2.442a2.477,2.477,0,0,0,2.32.7,7.431,7.431,0,0,1,6.96,2.12c1.862,1.92,2.113,4.327.779,5.861a1.433,1.433,0,0,0,.258,1.954l2.367,2.441a3.157,3.157,0,0,0,3.654.732L54.9,38.256c1.025-.62,1.051-1.953.058-2.977l-2.367-2.442a2.479,2.479,0,0,0-2.32-.7,7.433,7.433,0,0,1-6.961-2.12c-1.861-1.92-2.112-4.327-.779-5.861a1.43,1.43,0,0,0-.257-1.954l-2.367-2.441a3.154,3.154,0,0,0-3.654-.732Z",
    transform: "translate(1.553 0.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5527",
    "data-name": "Path 5527",
    d: "M52.594,32.838a2.474,2.474,0,0,0-2.32-.7,7.436,7.436,0,0,1-6.961-2.121c-1.861-1.92-2.112-4.327-.779-5.861a1.429,1.429,0,0,0-.257-1.953l-2.367-2.442a3.155,3.155,0,0,0-3.654-.731L9.734,35.075c-1.024.619-1.05,1.953-.058,2.977l2.368,2.441a2.475,2.475,0,0,0,2.32.706,7.434,7.434,0,0,1,6.961,2.12c1.861,1.92,2.112,4.327.779,5.861a1.431,1.431,0,0,0,.257,1.954l2.367,2.441a3.269,3.269,0,0,0,3.354.877L53.79,34.072Z",
    transform: "translate(1.553 0.079)",
    fill: "#5c88da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5528",
    "data-name": "Path 5528",
    d: "M27.183,55.509A4.339,4.339,0,0,1,24.127,54.2L21.76,51.76a2.293,2.293,0,0,1-.29-3.129c1.058-1.215.751-3.142-.747-4.686a6.62,6.62,0,0,0-6.1-1.888,3.332,3.332,0,0,1-3.177-.938L9.076,38.679a3.121,3.121,0,0,1-.952-2.538,2.425,2.425,0,0,1,1.183-1.787L35.83,18.306a4.01,4.01,0,0,1,4.727.87l2.367,2.442a2.292,2.292,0,0,1,.29,3.128c-1.058,1.216-.751,3.143.747,4.687a6.62,6.62,0,0,0,6.1,1.888,3.33,3.33,0,0,1,3.177.937L55.608,34.7a3.12,3.12,0,0,1,.952,2.538,2.421,2.421,0,0,1-1.183,1.786l-8.844,5.351a.869.869,0,0,1-.9-1.487l8.844-5.35a.7.7,0,0,0,.36-.523,1.438,1.438,0,0,0-.477-1.106l-2.367-2.441a1.618,1.618,0,0,0-1.464-.472,8.332,8.332,0,0,1-7.818-2.353c-2.151-2.218-2.485-5.111-.81-7.036.145-.166.05-.494-.225-.778l-2.368-2.442a2.327,2.327,0,0,0-2.579-.594L10.207,35.84a.7.7,0,0,0-.359.523,1.436,1.436,0,0,0,.477,1.106l2.367,2.442a1.624,1.624,0,0,0,1.464.472,8.331,8.331,0,0,1,7.818,2.352c2.151,2.219,2.484,5.112.81,7.036-.145.167-.05.494.225.779l2.367,2.441a2.329,2.329,0,0,0,2.58.594l14.752-8.926a.869.869,0,1,1,.9,1.486L28.854,55.071a3.211,3.211,0,0,1-1.67.439",
    transform: "translate(1.531 0.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5529",
    "data-name": "Path 5529",
    d: "M9.272,35.1a2.476,2.476,0,0,0,0,3.5l2.306,2.306a1.831,1.831,0,0,0,2.229.281,5.507,5.507,0,0,1,7.539,7.539,1.833,1.833,0,0,0,.281,2.229l2.3,2.306a2.477,2.477,0,0,0,3.5,0L52.477,28.22a2.478,2.478,0,0,0,0-3.5l-2.306-2.306a1.835,1.835,0,0,0-2.23-.281A5.506,5.506,0,0,1,40.4,14.592a1.835,1.835,0,0,0-.281-2.23l-2.306-2.306a2.478,2.478,0,0,0-3.5,0Z",
    transform: "translate(1.543 -0.176)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5530",
    "data-name": "Path 5530",
    d: "M52.078,27.889a2.476,2.476,0,0,0,0-3.5L49.772,22.08a1.835,1.835,0,0,0-2.157-.323l2.359,2.359a1.559,1.559,0,0,1,0,2.205L24.286,52.012a2.46,2.46,0,0,1-1.046.623l.295.295a2.478,2.478,0,0,0,3.5,0Z",
    transform: "translate(1.942 0.156)",
    fill: "#ffa92c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5531",
    "data-name": "Path 5531",
    d: "M37.391,13.674a5.507,5.507,0,0,0,3.9,8.235,5.513,5.513,0,0,1-1.6-7.317,1.831,1.831,0,0,0-.281-2.229l-2.3-2.306a2.475,2.475,0,0,0-2.079-.7l2.091,2.091a1.832,1.832,0,0,1,.281,2.23",
    transform: "translate(2.261 -0.176)",
    fill: "#ffa92c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5532",
    "data-name": "Path 5532",
    d: "M23.344,48.795a5.506,5.506,0,0,0-3.9-8.235,5.513,5.513,0,0,1,1.6,7.317,1.833,1.833,0,0,0,.281,2.229l2.3,2.306a2.477,2.477,0,0,0,2.08.7l-2.091-2.091a1.835,1.835,0,0,1-.281-2.23",
    transform: "translate(1.839 0.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5533",
    "data-name": "Path 5533",
    d: "M40.122,12.362l-2.306-2.306a2.478,2.478,0,0,0-3.5,0L9.272,35.1a2.478,2.478,0,0,0,0,3.5l2.306,2.306a1.832,1.832,0,0,0,2.23.281c.073-.043.147-.084.222-.124l-2.2-2.194a1.559,1.559,0,0,1,0-2.205l24.5-24.5a1.559,1.559,0,0,1,2.205,0l2.034,2.035a1.831,1.831,0,0,0-.456-1.832",
    transform: "translate(1.543 -0.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5534",
    "data-name": "Path 5534",
    d: "M17.113,32.66a.867.867,0,0,1-.614-.255L13.9,29.811a.869.869,0,0,1,1.228-1.228l2.595,2.595a.869.869,0,0,1-.614,1.483",
    transform: "translate(1.681 0.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5535",
    "data-name": "Path 5535",
    d: "M22.166,37.713a.867.867,0,0,1-.614-.255l-2.595-2.595a.869.869,0,0,1,1.228-1.228l2.595,2.595a.869.869,0,0,1-.614,1.483",
    transform: "translate(1.818 0.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5536",
    "data-name": "Path 5536",
    d: "M27.219,42.766a.867.867,0,0,1-.614-.255L24.01,39.916a.869.869,0,1,1,1.228-1.228l2.595,2.595a.869.869,0,0,1-.614,1.483",
    transform: "translate(1.956 0.614)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5537",
    "data-name": "Path 5537",
    d: "M32.271,47.818a.867.867,0,0,1-.614-.255l-2.595-2.595A.869.869,0,0,1,30.29,43.74l2.595,2.595a.869.869,0,0,1-.614,1.483",
    transform: "translate(2.093 0.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5538",
    "data-name": "Path 5538",
    d: "M25.708,54.879a3.324,3.324,0,0,1-2.366-.98l-2.306-2.306a2.7,2.7,0,0,1-.415-3.285,4.638,4.638,0,0,0-6.349-6.35,2.7,2.7,0,0,1-3.286-.415l-2.306-2.3a3.346,3.346,0,0,1,0-4.732l20.5-20.5a.869.869,0,0,1,1.228,1.23l-20.5,20.5a1.609,1.609,0,0,0,0,2.274l2.306,2.306a.966.966,0,0,0,1.174.148,6.375,6.375,0,0,1,8.729,8.729.963.963,0,0,0,.147,1.173l2.306,2.306a1.611,1.611,0,0,0,2.274,0L51.886,27.629a1.611,1.611,0,0,0,0-2.274L49.58,23.049a.963.963,0,0,0-1.173-.147,6.375,6.375,0,0,1-8.729-8.729A.966.966,0,0,0,39.531,13l-2.306-2.306a1.611,1.611,0,0,0-2.274,0,.869.869,0,1,1-1.228-1.228,3.349,3.349,0,0,1,4.731,0l2.306,2.306a2.7,2.7,0,0,1,.415,3.285,4.638,4.638,0,0,0,6.35,6.35,2.7,2.7,0,0,1,3.285.415l2.306,2.306a3.349,3.349,0,0,1,0,4.731L28.074,53.9a3.324,3.324,0,0,1-2.366.98",
    transform: "translate(1.52 -0.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5539",
    "data-name": "Path 5539",
    d: "M31.128,13.472a.869.869,0,0,1-.614-1.483l.648-.649a.869.869,0,1,1,1.23,1.23l-.649.648a.867.867,0,0,1-.614.255",
    transform: "translate(2.132 -0.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5540",
    "data-name": "Path 5540",
    d: "M30.308,37.253a.869.869,0,0,1-.615-1.483l9.082-9.082A.869.869,0,0,1,40,27.916L30.921,37a.867.867,0,0,1-.613.255",
    transform: "translate(2.11 0.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5541",
    "data-name": "Path 5541",
    d: "M25.255,32.2a.869.869,0,0,1-.614-1.483l9.082-9.082a.869.869,0,0,1,1.228,1.228l-9.082,9.082a.867.867,0,0,1-.614.255",
    transform: "translate(1.973 0.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5542",
    "data-name": "Path 5542",
    d: "M27.781,34.726a.869.869,0,0,1-.614-1.483l9.082-9.082a.869.869,0,0,1,1.228,1.228L28.4,34.471a.867.867,0,0,1-.614.255",
    transform: "translate(2.041 0.22)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketFeatureIcon);
export default __webpack_public_path__ + "static/media/ticket_feature_icon.61f549790d9922ba2ec82ca346d1eaa1.svg";
export { ForwardRef as ReactComponent };